import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Table, DatePicker, Typography } from "antd";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useGetEmpContractReport } from "AppQuries/report/get-emp-contract-report";
import useTableExport from "core/Operations/useTableExport";
import { formatDate } from "core/Operations/dateFormat";
import { useTableSearch } from "core/Operations/useTableSearch";
import ReportTools from "Components/UI/ReportTools";
import TableTop from "Components/UI/TableTop";
import { all_routes } from "Router/all_routes";
import { Link } from "react-router-dom";
import {
  useFormattedDepartmentOption,
  useFormattedEmployees,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { startOfMonth } from "date-fns";
import { format } from "date-fns";
import Select from "react-select";
import { BackIcon } from "Components/UI/Icon/Icons";

const { RangePicker } = DatePicker;

const EmpContractReport = () => {
  const userData = useSelector(loggedInUser);
  const [isMount, setIsMount] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const [queryParams, setQueryParams] = useState(() => {
    const fromDate = format(startOfMonth(new Date()), "yyyy-MM-dd");
    const toDate = format(startOfMonth(new Date()), "yyyy-MM-dd");
    return {
      fromDate,
      toDate,
      employeeCode: 0,
      departmentCode: 0,
      projectCode: 0,
    };
  });

  const departmentOptions = useFormattedDepartmentOption(userData?.companyCode);

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: queryParams?.departmentCode,
  });

  const {
    data: reportData,
    isLoading,
    isError,
    isFetching,
    refetch: getReport,
  } = useGetEmpContractReport(
    {
      companyCode: userData?.companyCode ?? "",
      locationCode: userData?.selectedLocationCode ?? "",
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      ...queryParams,
    },
    {
      enabled:
        !!userData?.companyCode &&
        !!userData?.locationCode &&
        !!queryParams?.fromDate &&
        !!queryParams?.toDate,
    },
  );

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID - b.uniqueID,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      key: "employeeName",
    },
    {
      title: "Department Name",
      dataIndex: "departmentName",
      key: "departmentName",
    },
    {
      title: "Project Name",
      dataIndex: "projectName",
      key: "projectName",
    },
    {
      title: "Location Name",
      dataIndex: "locationCode",
      key: "locationCode",
    },
    {
      title: "Contract Duration",
      dataIndex: "contractCode",
      key: "contractCode",
    },
    {
      title: "Contract Expiry Date",
      dataIndex: "contractExpiryDate",
      key: "contractExpiryDate",
      render: (record, text) => {
        return formatDate(text, "dd-MM-yyyy");
      },
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    reportData,
    searchColumns,
  );

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  //   useEffect(() => {
  //     if (isMount) getEmployee();

  //     setIsMount(true);
  //   }, [queryParams?.departmentCode]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Employee Contact Report</h4>
              {/* <h6>Employee Documents Expiry Summary Report</h6> */}
            </div>
          </div>

          <ReportTools
            columns={columns}
            data={reportData}
            fileName={`Employee Contact Report`}
            pdfTheme="striped"
            refresh={getReport}
          />

          <div className="page-btn">
            <Link className="btn btn-secondary" to={all_routes.report_list}>
              <BackIcon className="me-2" />
              Back
            </Link>
          </div>
        </div>

        <div className="card table-list-card border-0">
          <div className="card-body">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
              showToggle={true}
            />
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              // style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="form-row row">
                  <div className="row">
                    {/* <div className="col-lg-3 col-sm-6 col-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">Employee </label>
                      <Select
                        className="select"
                        options={employeeOptions}
                        placeholder="Employee"
                        value={employeeOptions.find(
                          (option) => option.value === employeeCode
                        )}
                        onChange={(e) => {
                          setEmployeeCode(e?.value || 0);
                        }}
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="absolute"
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            zIndex: 111,
                          }),
                          menuPortal: (baseStyles) => ({
                            ...baseStyles,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                  </div> */}
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">
                          Start Date – End Date
                        </label>
                        <RangePicker
                          //   disabledDate={DisabledDate}
                          className="form-control"
                          style={{ display: "flex" }}
                          onChange={(date, dateFormat) => {
                            updateQueryParams("fromDate", dateFormat[0]);
                            updateQueryParams("toDate", dateFormat[1]);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Department</label>
                        <Select
                          className="select"
                          options={departmentOptions}
                          placeholder="Department"
                          value={departmentOptions.find(
                            (option) =>
                              option.value === queryParams.departmentCode,
                          )}
                          onChange={(e) => {
                            updateQueryParams("departmentCode", e?.value || 0);
                          }}
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Employee</label>
                        <Select
                          className="select"
                          options={employeeOptions}
                          placeholder="Select Employee"
                          value={
                            employeeOptions.find(
                              (option) =>
                                option.value === queryParams.employeeCode,
                            ) || ""
                          }
                          onChange={(e) => {
                            updateQueryParams("employeeCode", e?.value || 0);
                          }}
                          isClearable
                        />
                      </div>
                    </div>

                    <div className="col-lg-1 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label className="form-label">&nbsp;</label>
                        <Link
                          className="btn btn-filters ms-auto"
                          onClick={() => {
                            //   setSelectedRowKeys([]);
                            getReport();
                          }}
                          type="button"
                        >
                          <i data-feather="search" className="feather-search" />
                          {/* {isFetching ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-2"></i>
                              Loading...
                            </>
                          ) : ( */}
                          <>Filter</>
                          {/* )} */}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                loading={isLoading}
                columns={columns}
                dataSource={reportData}
                rowKey={(record) =>
                  `${record.contractCode}-${record.employeeCode}`
                }
                bordered
                pagination={true}
                // components={{
                //   header: {
                //     cell: (props) => (
                //       <th
                //         {...props}
                //         className="bg-secondary text-white text-center p-3"
                //       />
                //     ),
                //   },
                // }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmpContractReport;
